import { render } from "./ProfileGeneralTab.vue?vue&type=template&id=68ec86a0&scoped=true&ts=true"
import script from "./ProfileGeneralTab.vue?vue&type=script&lang=ts"
export * from "./ProfileGeneralTab.vue?vue&type=script&lang=ts"

import "./ProfileGeneralTab.vue?vue&type=style&index=0&id=68ec86a0&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ec86a0"]])

export default __exports__